import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { capitalizeFirstLetterOfEachWord } from "../../../Components/Functions/word.fun";
import { useSelector } from "react-redux";
import { FcCalendar } from "react-icons/fc";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import StepRoutes from "../../../Routes/steps_routes";

const ViewTasks = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const user = useSelector((store) => store.login.user);
  let { id } = useParams();

  const RowData = ({ label, value }) => (
    <tr>
      <td className="text-secondary">
        <span className="ms-1">{label}</span>
      </td>
      <td>{value || "N/A"}</td>
    </tr>
  );

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/kitTracking/getKitTracking/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Tasks!");
        }
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2  me-1" /> View Kit Tracking
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4 text-end">
                {data?.kitStatus && (
                  <span
                    className={`badge fs-5 text-dark ${
                      data.kitStatus === "Delivered"
                        ? "bg-success"
                        : data.kitStatus === "Ordered"
                        ? "bg-warning"
                        : data.kitStatus === "Dispatched"
                        ? "bg-warning"
                        : "bg-secondary"
                    }`}
                  >
                    {data.kitStatus}
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-3">
                <p>Track Your Kit Tracking.</p>
              </div>
            </div>
            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Kit Tracking Spec</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <>
                          <RowData
                            label="Client Name"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.clientName
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Contact Number"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.clientContactNumber
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Address"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.clientAddress
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Kit Type"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.typeOfKit
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Kit Price"
                            value={
                              capitalizeFirstLetterOfEachWord(data?.kitPrice) ||
                              "N/A"
                            }
                          />
                          <RowData
                            label="Kit Order Date"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.orderDate
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Courier Service Provider"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.courierServiceProvider
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Courier Person Name"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.courierServiceProviderPersonName
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Courier Person Contact Number"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.courierServiceProviderPersonContactNumber
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Courier Service Charge"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.courierServiceCharge
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Courier Tracking Id"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.courierTrackingId
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Kit Dispatch Date"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.dispatchDate
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Kit Dispatch Address"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.kitDispatchAddress
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Kit Delivered Date"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.deliveryDate
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Generated By"
                            value={
                              capitalizeFirstLetterOfEachWord(
                                data?.generatedBy
                              ) || "N/A"
                            }
                          />
                          <RowData
                            label="Note"
                            value={
                              capitalizeFirstLetterOfEachWord(data?.note) ||
                              "N/A"
                            }
                          />
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    {(user.UserId == data?.generatedBy ||
                      user.Role === process.env.REACT_APP_ROLE_ADMIN_S) && (
                      <SimpleButton
                        buttonText="Edit Kit Tracking"
                        href={`/kitTracking/edit/${id}`}
                      />
                    )}
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewTasks;
